import React, { useState,useEffect } from 'react';
import { ModalBox,CustomLoader,DisplayStarRating } from "../../Services/CommonLibrary"
import { ServiceVocList } from "../../Services/Service";
import Table from '../DataTable/DataTable';
import {formatUkNumber} from "../Utils";

function StarRating(props) {
  // console.log("=====",props.data);
  const data = props.data[0];

  const startRange = props.startRange;
  const endRange = props.endRange;
  const divisionClinicFilter = props.divisionClinicFilter;
  const programSelect = props.programSelect;

  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const handleClose = () =>setShowModal(false);
  const [serviceData, setServiceData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
      
  },[serviceData]);
  const fetchVocList = (rating) => {
    setLoading(true);
    ServiceVocList(rating,startRange,endRange,divisionClinicFilter,programSelect)
        .then((res) => {
            if(res.data.status!=1){
              res.data.data='';
            }
            setShowModal(true);
            setModalTitle('Coach Rating: '+rating+' Star');
            const columns = [
              {id:1,name: "#",cell: (row, index) => index + 1,sortable: false,grow: 0},
              {id:2,name : <div className='tdData text-start'>Patient Name</div>,  selector:row=>row.userName, cell: row => <div className='tdData'>{row.userName}</div>,sortable: true},
              {id:3,name : <div className='tdData text-start'>Coach Name</div>,selector: row => row.coachName, cell: row => <div className='tdData'>{row.coachName}</div>,sortable: true},
              {id:5,name : <div className='tdData text-start'>Coach Rating</div>,selector: row => row.coachFeedbackRating, cell: row => <div className='tdData'>{row.coachFeedbackRating}</div>,sortable: true},
              {id:6,name : <div className='tdData text-start'>Date Time</div>,selector: row => row.createdTime, cell: row => <div className='tdData'>{row.createdTime}</div>,sortable: true}

            ];    
            const bodyCopmp = <Table data={res.data.data} column={columns} title="" id="coachRatingTable" />
            setModalBody(bodyCopmp);
            setLoading(false);
        });
}
  const viewpopup = (rating)=>{
    fetchVocList(rating);
  }
  
    return (
      <>
                      <div className="row align-items-center mt-5">
                        <div className="col-auto">
                          <div id="half-stars-example">
                                <div className="rating-group">
                                    <DisplayStarRating value={data.totalnorating}/>
                                    {/* <label aria-label="0.5 stars" className="rating__label rating__label--half" htmlFor="rating2-05"><i className="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-05" value="0.5" type="radio"/>

                                    <label aria-label="1 star" className="rating__label" htmlFor="rating2-10"><i className="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-10" value="1" type="radio"/>

                                    <label aria-label="1.5 stars" className="rating__label rating__label--half" htmlFor="rating2-15"><i className="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-15" value="1.5" type="radio"/>

                                    <label aria-label="2 stars" className="rating__label" htmlFor="rating2-20"><i className="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-20" value="2" type="radio"/>

                                    <label aria-label="2.5 stars" className="rating__label rating__label--half" htmlFor="rating2-25"><i className="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-25" value="2.5" type="radio"/>

                                    <label aria-label="3 stars" className="rating__label" htmlFor="rating2-30"><i className="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-30" value="3" type="radio" />

                                    <label aria-label="3.5 stars" className="rating__label rating__label--half" htmlFor="rating2-35"><i className="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-35" value="3.5" type="radio"/>

                                    <label aria-label="4 stars" className="rating__label" htmlFor="rating2-40"><i className="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-40" value="4" type="radio"/>

                                    <label aria-label="5.5 stars" className="rating__label rating__label--half" htmlFor="rating2-45"><i className="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-45" value="5.5" type="radio" checked readOnly/>
                                    
                                    <label aria-label="5 stars" className="rating__label" htmlFor="rating2-50"><i className="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input className="rating__input" name="rating2" id="rating2-50" value="5" type="radio"/> */}
                                </div>
                            </div>
                        </div>

                        <div className="col">
                          <h3 className="mb-0 ps-0">{data.totalnorating ? data.totalnorating : 0} out of 5</h3>
                        </div>
                   </div>

                   <div className="row">
                        <div className="col-12 mt-2">
                            <h4 className="mt-1 mb-1">Total Rating: {formatUkNumber(data.norating)}</h4>
                        </div>
                   </div>

                   <div className="row mt-2 align-items-center mb-3" onClick={(e)=>viewpopup(5)}  style={{cursor:'pointer'}}>
                        <div className="col-auto">
                            <h2 className="btn-starrating">5 Star</h2>
                        </div>
                        <div className="col-6">
                          <div className="progress progress-starrating" role="progressbar" aria-label="" aria-valuenow={data.star5percent ? data.star5percent : 0} aria-valuemin="0" aria-valuemax="100">
                            <div className="progress-bar bg-warning" style={{ width: `${data.star5percent ? data.star5percent : 0}%` }}></div>
                          </div>
                        </div>
                        <div className="col-auto ps-0">
                            <h2 className="btn-starrating">{data.star5percent ? data.star5percent : 0}%</h2>
                        </div>
                   </div>

                   <div className="row mt-2 align-items-center mb-3" onClick={(e)=>viewpopup(4)}  style={{cursor:'pointer'}}>
                        <div className="col-auto">
                            <h2 className="btn-starrating">4 Star</h2>
                        </div>
                        <div className="col-6">
                          <div className="progress progress-starrating" role="progressbar" aria-label="" aria-valuenow={data.star4percent ? data.star4percent : 0} aria-valuemin="0" aria-valuemax="100">
                            <div className="progress-bar bg-warning" style={{ width: `${data.star4percent ? data.star4percent : 0}%` }}></div>
                          </div>
                        </div>
                        <div className="col-auto ps-0">
                            <h2 className="btn-starrating">{data.star4percent ? data.star4percent : 0}%</h2>
                        </div>
                   </div>

                   <div className="row mt-2 align-items-center mb-3" onClick={(e)=>viewpopup(3)}  style={{cursor:'pointer'}}>
                        <div className="col-auto">
                            <h2 className="btn-starrating">3 Star</h2>
                        </div>
                        <div className="col-6">
                          <div className="progress progress-starrating" role="progressbar" aria-label="" aria-valuenow={data.star3percent ? data.star3percent : 0} aria-valuemin="0" aria-valuemax="100">
                            <div className="progress-bar bg-warning" style={{ width: `${data.star3percent ? data.star3percent : 0}%` }}></div>
                          </div>
                        </div>
                        <div className="col-auto ps-0">
                            <h2 className="btn-starrating">{data.star3percent ? data.star3percent : 0}%</h2>
                        </div>
                   </div>

                   <div className="row mt-2 align-items-center mb-3" onClick={(e)=>viewpopup(2)}  style={{cursor:'pointer'}}>
                        <div className="col-auto">
                            <h2 className="btn-starrating">2 Star</h2>
                        </div>
                        <div className="col-6">
                          <div className="progress progress-starrating" role="progressbar" aria-label="" aria-valuenow={data.star2percent ? data.star2percent : 0} aria-valuemin="0" aria-valuemax="100">
                            <div className="progress-bar bg-warning" style={{ width: `${data.star2percent ? data.star2percent : 0}%` }}></div>
                          </div>
                        </div>
                        <div className="col-auto ps-0">
                            <h2 className="btn-starrating">{data.star2percent ? data.star2percent : 0}%</h2>
                        </div>
                   </div>

                   <div className="row mt-2 align-items-center" onClick={(e)=>viewpopup(1)}  style={{cursor:'pointer'}}>
                        <div className="col-auto">
                            <h2 className="btn-starrating">1 Star</h2>
                        </div>
                        <div className="col-6">
                          <div className="progress progress-starrating" role="progressbar" aria-label="" aria-valuenow={data.star1percent ? data.star1percent : 0} aria-valuemin="0" aria-valuemax="100">
                            <div className="progress-bar bg-warning" style={{ width: `${data.star1percent ? data.star1percent : 0}%` }}></div>
                          </div>
                        </div>
                        <div className="col-auto ps-0">
                            <h2 className="btn-starrating">{data.star1percent ? data.star1percent : 0}%</h2>
                        </div>
                   </div>

                   {showModal?<ModalBox handleClose={handleClose} showModaln={showModal} titlen={modalTitle} bodyn={modalBody}/>:null}     
      </>
    );
  
}

export default StarRating;
